import { post,get} from '../../libs/ajax.js'
/**
 * 产品搜索
 * @param {*} data 
 * @returns 
 */
export function appEntrySearchListApi (data) {
    return post('/entry_app/get_search_list', data)
}
/**
 * 产品列表
 * @param {*} data 
 * @returns 
 */
export function appEntryListApi (data) {
    return post('/entry_app/get_list', data)
}
/**
 * 获取配置的数据
 * @param {*} data 
 * @returns 
 */
export function getAppEntryCnfigApi (data) {
    return get('/entry_app/get_config_list', data)
}
/**
 * 获取客户列表
 * @param {*} data 
 * @returns 
 */
export function getAppEntryCustomerListApi (data) {
    return post('/entry_app/get_customer_list', data)
}
/**
 * 新增产品
 * @param {*} data 
 * @returns 
 */
export function appEntryBatchAddApi (data) {
    return post('/entry_app/batch_add', data)
}
/**
 * 编辑产品
 * @param {*} data 
 * @returns 
 */
export function appEntryEditApi (data) {
    return post('/entry_app/edit', data)
}
/**
 * 获取产品录入配置
 * @param {*} data 
 * @returns 
 */
export function getAppEntryGetMap (data) {
    return get('/entry_app/get_map', data)
}

/**
 * 获取产品录入 列表表头 与 批量添加表头
 * @param {*} data 
 * @returns 
 */
export function getAppEntryGetFiled (data) {
    return get('/entry_app/get_field', data)
}

/**
 * 获取产品录入 列表表头 与 批量添加表头
 * @param {*} data 
 * @returns 
 */
export function postAppEntryDetail (data) {
    return post('/entry_app/detail', data)
}

/**
 * 获取产品录入 筛选字段
 * @param {*} data 
 * @returns 
 */
export function getAppEntryField (data) {
    return get('/entry_app/get_search_field', data)
}

/**
 * 获取产品录入 校验信息
 * @param {*} data 
 * @returns 
 */
export function getAppEntryValidation(data) {
    return get('/entry_app/get_validation_by_param', data)
}


